/**
 * Animation pool singleton
 */
export class AnimationPoolWrapper {
    static _Map = new Map();
    instance;
    pool;
    _referenceCount;
    constructor(instance, pool) {
        this.instance = instance;
        this.pool = pool;
        this._referenceCount = 0;
    }
    /**
     * @internal
     */
    addReference() {
        this._referenceCount += 1;
    }
    /**
     * @internal
     */
    removeReference() {
        this._referenceCount -= 1;
        if (this._referenceCount === 0) {
            this.pool.free();
            AnimationPoolWrapper._Map.delete(this.instance);
        }
    }
    /**
     * Get animation pool
     * @param instance MMD WASM instance
     * @returns Animation pool for the WASM instance
     */
    static Get(instance) {
        let poolWrapper = this._Map.get(instance);
        if (!poolWrapper) {
            const pool = instance.createAnimationPool();
            poolWrapper = new AnimationPoolWrapper(instance, pool);
            this._Map.set(instance, poolWrapper);
        }
        return poolWrapper;
    }
}
